import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'rsuite/dist/rsuite.min.css'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>,
  document.getElementById('root')
);
